import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vem får sälja alkohol via gårdsförsäljning?";
const SHORT_ANSWER = "Producenter som tillverkar alkoholdrycker på den egna anläggningen och har tillstånd från Folkhälsomyndigheten/kommun för gårdsförsäljning.";

export const Route = createFileRoute("/fraga/vem-far-salja-pa-gardsforsaljning")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vem får sälja alkohol via gårdsförsäljning" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Produkten ska vara tillverkad på platsen där försäljningen sker. Importerade drycker eller produkter från annan tillverkare omfattas inte av gårdsförsäljningen."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning/regler-2026", label: "Regler för gårdsförsäljning 2026" }}
      related={[{"to": "/fraga/hur-mycket-far-jag-salja-per-besokare", "label": "Hur mycket alkohol får jag sälja per besökare vid gårdsförsäljning?"}, {"to": "/fraga/behover-jag-egen-tillverkning", "label": "Måste jag tillverka själv för att få gårdsförsäljning?"}, {"to": "/fraga/vad-ar-gardsforsaljning-2026", "label": "Vad är gårdsförsäljning enligt det nya regelverket 2026?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vem får sälja alkohol via gårdsförsäljning?" },
      { name: "description", content: "Producenter som tillverkar alkoholdrycker på den egna anläggningen och har tillstånd från Folkhälsomyndigheten/kommun för gårdsförsäljning." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vem-far-salja-pa-gardsforsaljning" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vem-far-salja-pa-gardsforsaljning" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vem-far-salja-pa-gardsforsaljning",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vem får sälja alkohol via gårdsförsäljning", url: "https://alkoholprovet.se/fraga/vem-far-salja-pa-gardsforsaljning" },
      ]),
    ],
  }),
});
